import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

export interface GLDashboardData {
  [key: string]: unknown;
}

export const fetchGLDashboardDataService = async (params?: {
  areaIds?: string[];
  businessUnitIds?: string[];
  fieldIds?: string[];
  wellIds?: string[] | string;
}): Promise<any> => {
  const requestPayload = createWrapperPayload(
    'GET',
    '/pumpchecker/Checker/GasLiftReport/DashboardData',
    undefined,
    false,
    params?.areaIds,
    params?.businessUnitIds,
    params?.fieldIds,
    params?.wellIds,
  );
  const resp = await api.post(wrapperConstants.router, requestPayload);
  return resp?.data ?? undefined;
};
